/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export enum KachelColor {
    primary,
    secondary,
    tertiary
}

export enum KachelIdentifier {
    teilnahmen,
    seminare,
    belege,
    fibuExporte,
    auswertungen,
    grundeinstellungen,
    buchungsportal,
    ticketscanner,
    faq,
    support,
    verbesserungsvorschlag,
    roadmap,
    neuigkeiten,
    adressen,
    dozierende,
    artikel,
    bestellterArtikel,
    ressourcenplan,
    bestellungen,
    seminarreihen,
    kooperationspartner,
    belegungen,
    zahlungen
}

// Diese Struktur sollten später die Kacheln am Server besitzen
export default interface KachelInfo {
    block: number;
    caption: string;
    kachelIdentifier: KachelIdentifier;
    color: KachelColor;
}